<app-toggler
  color="grey-80"
  headerSize="big"
  bodyPadding="none"
  special="theme-font"
  iconSize="small"
  (onOpen)="onOpen.emit()"
  (onClose)="onClose.emit()"
  [open]="open()"
>
  <div togglerHeader class="toggler-header" [appApplyTypographyStyles]="theme().cover.paragraph_typography">
    Cover Description
  </div>
  <div togglerBody class="toggler-body">
    <app-theme-font-family-item
      [fontFamily]="theme().cover.paragraph_typography.font_family"
      (fontFamilyChange)="updateCoverParagraph({ font_family: $event })"
    ></app-theme-font-family-item>
    <app-theme-single-color-item
      [color]="theme().cover.paragraph_typography.font_color"
      [gallery]="gallery()"
      [small]="true"
      (colorChange)="updateCoverParagraph({ font_color: $event })"
    ></app-theme-single-color-item>
    <app-theme-font-size-item
      [fontSize]="theme().cover.paragraph_typography.font_size"
      [allowHuge]="false"
      (fontSizeChange)="updateCoverParagraph({ font_size: $event })"
    ></app-theme-font-size-item>
    <app-theme-font-weight-item
      [fontFamily]="theme().cover.paragraph_typography.font_family"
      [fontWeight]="theme().cover.paragraph_typography.font_weight"
      (fontWeightChange)="updateCoverParagraph({ font_weight: $event })"
    ></app-theme-font-weight-item>
    <app-theme-font-style-item
      [fontFamily]="theme().cover.paragraph_typography.font_family"
      [fontStyle]="theme().cover.paragraph_typography.font_style"
      (fontStyleChange)="updateCoverParagraph({ font_style: $event })"
    ></app-theme-font-style-item>
    <app-theme-text-transform-item
      [textTransform]="theme().cover.paragraph_typography.text_transform"
      (textTransformChange)="updateCoverParagraph({ text_transform: $event })"
    ></app-theme-text-transform-item>
    <app-theme-letter-spacing-item
      [letterSpacing]="theme().cover.paragraph_typography.letter_spacing"
      (letterSpacingChange)="updateCoverParagraph({ letter_spacing: $event })"
    ></app-theme-letter-spacing-item>
  </div>
</app-toggler>
